export const ADMIN_ROLES = Object.freeze({
    SUPERADMIN: "Cуперадминистратор",
    ADMINISTRATOR: "Администратор",
    ACCOUNTANT: "Бухгалтер",
    OWNER: "Владелец",
    DEPLOYER: "Внедренец",
    IMPLEMENTATION_HEAD: "Отдел внедрения",
    AGENT: "Агент",
    BRANCH: "Филиал",
    WORKER: "Работник",
});

export const KNOWN_ADMIN_ROLES = new Set(Object.values(ADMIN_ROLES));

const ROLE_LABEL_KEYS = {
    [ADMIN_ROLES.SUPERADMIN]: "shell.roles.superadmin",
    "Суперадминистратор": "shell.roles.superadmin",
    [ADMIN_ROLES.ADMINISTRATOR]: "shell.roles.administrator",
    [ADMIN_ROLES.ACCOUNTANT]: "shell.roles.accountant",
    [ADMIN_ROLES.OWNER]: "shell.roles.owner",
    [ADMIN_ROLES.DEPLOYER]: "shell.roles.deployer",
    [ADMIN_ROLES.IMPLEMENTATION_HEAD]: "shell.roles.implementationHead",
    [ADMIN_ROLES.AGENT]: "shell.roles.agent",
    [ADMIN_ROLES.BRANCH]: "shell.roles.branch",
    [ADMIN_ROLES.WORKER]: "shell.roles.worker",
};

export const translateAdminRole = (role, t) => {
    const key = ROLE_LABEL_KEYS[role];
    return key ? t(key) : role;
};
